(() => {
  const clean = scope => {
    const header = scope.matches?.('.lcn-header') ? scope : scope.querySelector?.('.lcn-header');
    if (!header?.querySelector('lcn-navigation[data-lcn-beauty]')) return;
    const walker = document.createTreeWalker(header, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (node.parentElement?.closest('script,style')) continue;
      if (/[\u2190-\u2199\u203a\u2039]/.test(node.nodeValue)) nodes.push(node);
    }
    nodes.forEach(node => {
      node.nodeValue = node.nodeValue.replace(/[\u2190-\u2199\u203a\u2039]/g, '');
    });
  };
  customElements.whenDefined('lcn-navigation').then(() => requestAnimationFrame(() => clean(document)));
  document.addEventListener('shopify:section:load', event => requestAnimationFrame(() => clean(event.target)));
})();
